/* LIBRAIRIES */
import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";

/* CONTEXT */
import { UserContext } from './useContext';

/* CSS */
import './App.css';

/* PAGES */
import Accueil from './Pages/Accueil/Accueil';
import NosPrestations from './Pages/NosPrestations/NosPrestations';
import Fiscal from './Pages/Fiscal/Fiscal';
import Login from './Pages/Login/Login';
import Dashboard from './Pages/Dashboard/Dashboard';
import SignUp from './Pages/SignUp/SignUp';

/* COMPONENTS */
import Navbar from './Components/Navbar/Navbar';
import Footer from './Components/Footer/Footer';
import ProtectedRoute from './Components/ProtectedRoute/ProtectedRoute';
import Devis from './Pages/Devis/Devis';

function App() {
    const [userRole, setUserRole] = useState('');
    const [userModifyRole, setUserModifyRole] = useState('');
    const [openModalDeleteUser, setOpenModalDeleteUser] = useState(false);
    const [openModalModifyUser, setOpenModalModifyUser] = useState(false);
    const [openModalUserDocs, setOpenModalUserDocs] = useState(false);
    const [userMediasList, setUserMediasList] = useState([]);
    const [userId, setUserId] = useState('');
    const [userInfos, setUserInfos] = useState({});

    return (
        <BrowserRouter>
            <UserContext.Provider value={{ userRole, setUserRole, userId, setUserId, openModalDeleteUser, setOpenModalDeleteUser, userInfos, setUserInfos, openModalModifyUser, setOpenModalModifyUser, setUserModifyRole, userModifyRole, setUserMediasList, userMediasList, openModalUserDocs, setOpenModalUserDocs }}>
                <div className='App'>
                    <Navbar />
                        <div className='main-layout'>
                            <Routes>
                                <Route path="/" element={<Accueil />} />
                                <Route path="/Accueil" element={<Accueil />} />
                                <Route path="/NosPrestations" element={<NosPrestations />} />
                                <Route path="/Fiscal" element={<Fiscal />} />
                                <Route path="/Devis" element={<Devis />} />
                                <Route path="/Login" element={<Login />} />
                                <Route path="SignUp" element={<SignUp />} />
                                <Route path="/Dashboard" element={<ProtectedRoute />}>
                                    <Route exact path="/Dashboard" element={<Dashboard />}/>
                                </Route>
                            </Routes>
                        </div>
                    <Footer />
                </div>
            </UserContext.Provider>
        </BrowserRouter>
    );
}

export default App;
